import axios from 'axios'

let form = document.querySelectorAll('.js-form');

form.forEach(f => {

    let formInput = f.querySelector('.js-input');
    let formHeading = f.querySelector('.js-heading');
    let formSuccess = f.querySelector('.js-success');

    f.addEventListener('submit', e => {
        e.preventDefault()
        let formData = new FormData(f);

        // loop through formData and look for g-recaptcha-response and check if it's empty
        let hasCaptcha = false;
        for (const value of formData.entries()) {
            if (value[0] === 'g-recaptcha-response' && value[1] !== '') {
                hasCaptcha = true;
            }
        }

        if (!hasCaptcha) {
            formInput.style.display = 'none';
            formHeading.innerHTML = 'Error!';
            formSuccess.style.display = 'block';
            return;
        }

        axios
            .post('/', formData)
            .then(response => {
                formInput.style.display = 'none';
                formHeading.innerHTML = 'Thanks!';
                formSuccess.style.display = 'block';
            });
    });
});
